import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, MapPin, Search } from 'lucide-react';
import usePageTitle from '../hooks/usePageTitle';
import '../css/NotFound.css';

const NotFound = () => {
  usePageTitle('Page non trouvée');
  const navigate = useNavigate();

  return (
    <div className="not-found">
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Page non trouvée</h2>
        <p>Désolé, la page que vous recherchez n'existe pas ou a été déplacée.</p>
        
        <div className="suggestions">
          <h3>Vous pouvez :</h3>
          <div className="suggestion-buttons">
            <button 
              className="suggestion-btn"
              onClick={() => navigate('/')}
            >
              <Home size={20} />
              Retourner à l'accueil
            </button>
            
            <button 
              className="suggestion-btn"
              onClick={() => navigate('/carte')}
            >
              <MapPin size={20} />
              Explorer la carte
            </button>
            
            <button 
              className="suggestion-btn"
              onClick={() => navigate('/categories')}
            >
              <Search size={20} />
              Découvrir les établissements
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;